(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nm-product-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initProductHero = (section) => {
      if (!section || section.dataset.nmHeroInitialized === 'true') return;
      section.dataset.nmHeroInitialized = 'true';

      const appBlocks = section.querySelector('.nm-product-hero__app-blocks');
      const normalizeBundlePrices = () => {
        if (!appBlocks) return;
        const prices = ['899', '1 299', '1 559', '2 598', '1 949', '3 897'];
        const placeholder = '{' + '{amount_with_space_separator}' + '}';
        const placeholderPattern = new RegExp('\\{\\{amount_with_space_separator\\}\\}\\s*kr', 'g');
        let index = 0;
        const walker = document.createTreeWalker(appBlocks, NodeFilter.SHOW_TEXT);
        let node = walker.nextNode();
        while (node) {
          if (node.nodeValue.includes(placeholder) && index < prices.length) {
            node.nodeValue = node.nodeValue.replace(placeholderPattern, `${prices[index]} kr`);
            index += 1;
          }
          node = walker.nextNode();
        }
      };
      normalizeBundlePrices();
      if (appBlocks) {
        new MutationObserver(normalizeBundlePrices).observe(appBlocks, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      }

      const mainImage = section.querySelector('[data-main-image]');
      const thumbButtons = section.querySelectorAll('[data-thumb-button]');
      thumbButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (!mainImage) return;
          // The main image ships with a srcset for a fast, right-sized LCP. Once the
          // shopper swaps thumbnails we drop srcset/sizes so the chosen image wins.
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = button.dataset.imageSrc;
          mainImage.alt = button.dataset.imageAlt || mainImage.alt;
          thumbButtons.forEach((item) => item.classList.remove('is-active'));
          button.classList.add('is-active');
        });
      });

      // B-2 — tap the hero image to open a full-screen zoom lightbox (double-tap to zoom, drag to pan)
      const zoomOverlay = document.getElementById('nm-zoom-' + section.id.replace('shopify-section-', ''));
      if (mainImage && zoomOverlay) {
        const zoomImg = zoomOverlay.querySelector('[data-nm-zoom-img]');
        const stage = zoomOverlay.querySelector('[data-nm-zoom-stage]');
        const hiRes = (src) => (src || '').replace(/([?&])width=\d+/, '$1width=1400');
        let lastTap = 0;
        const openZoom = () => {
          const src = mainImage.currentSrc || mainImage.src;
          zoomImg.src = hiRes(src);
          zoomImg.alt = mainImage.alt || '';
          if (stage) { stage.classList.remove('is-zoomed'); stage.scrollTo(0, 0); }
          zoomOverlay.hidden = false;
          requestAnimationFrame(() => zoomOverlay.classList.add('is-open'));
          document.documentElement.classList.add('nm-sheet-lock');
        };
        const closeZoom = () => {
          zoomOverlay.classList.remove('is-open');
          document.documentElement.classList.remove('nm-sheet-lock');
          const done = () => {
            zoomOverlay.hidden = true;
            zoomImg.src = '';
            zoomOverlay.removeEventListener('transitionend', done);
          };
          zoomOverlay.addEventListener('transitionend', done);
          setTimeout(() => { if (!zoomOverlay.hidden) done(); }, 350);
        };
        mainImage.style.cursor = 'zoom-in';
        mainImage.addEventListener('click', openZoom);
        zoomOverlay.querySelector('[data-nm-zoom-close]')?.addEventListener('click', closeZoom);
        stage?.addEventListener('click', (event) => {
          if (event.target === stage) { closeZoom(); return; } // tap the backdrop to close
          const now = Date.now();
          if (now - lastTap < 300) {
            stage.classList.toggle('is-zoomed'); // double-tap toggles zoom
            lastTap = 0; // reset so a following tap starts a fresh pair
          } else {
            lastTap = now;
          }
        });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && zoomOverlay.classList.contains('is-open')) closeZoom();
        });
      }

      const form = section.querySelector('[data-product-form]');
      if (!form) return;

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const status = form.querySelector('[data-form-status]');
        const submit = form.querySelector('button[type="submit"]');
        const variantField = form.querySelector('[data-variant-select]') || form.querySelector('[data-variant-input]');
        const mainVariantId = Number(variantField?.value);

        if (!mainVariantId) return;

        if (status) {
          status.hidden = true;
          status.textContent = '';
        }

        submit.disabled = true;

        try {
          const addUrl = form.dataset.addUrl || `${window.Shopify?.routes?.root || '/'}cart/add.js`;
          const formData = new FormData(form);
          if (!formData.get('id')) formData.set('id', String(mainVariantId));
          if (!formData.get('quantity')) formData.set('quantity', '1');

          const response = await fetch(addUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
            },
            body: formData,
          });

          if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            throw new Error(errorData?.description || 'Kunne ikke legge varen i handlekurven.');
          }

          window.location.href = form.dataset.checkoutUrl || `${window.Shopify?.routes?.root || '/'}checkout`;
        } catch (error) {
          if (status) {
            status.hidden = false;
            status.textContent = error.message;
          }
          submit.disabled = false;
        }
      });
    };

    const initStickyBar = (section) => {
      const heroEl = section.querySelector('.nm-product-hero');
      if (!heroEl) return;
      const submit = heroEl.querySelector('.nm-product-hero__submit');
      const stickyBar = document.querySelector(
        '#nm-sticky-bar-' + heroEl.closest('.shopify-section')?.id?.replace('shopify-section-', ''),
      );
      if (!submit || !stickyBar) return;
      const stickyBtn = stickyBar.querySelector('[data-sticky-submit]');
      const observer = new IntersectionObserver(
        ([entry]) => {
          const visible = !entry.isIntersecting;
          stickyBar.setAttribute('aria-hidden', String(!visible));
          stickyBar.classList.toggle('is-visible', visible);
        },
        { threshold: 0 },
      );
      observer.observe(submit);
      stickyBtn?.addEventListener('click', () => {
        // B-5 — open the bottom-sheet bundle picker in the thumb zone (the sheet falls back to a
        // direct add-to-cart when no bundle widget is present).
        document.dispatchEvent(new CustomEvent('nm:open-tier-sheet'));
      });
    };

    // B-5 — bottom-sheet bundle picker: relocate the REAL bundle widget into a thumb-zone sheet on
    // open, restore it home on close/add so the app's own add-to-cart logic is never altered.
    const initTierSheet = (section) => {
      const heroEl = section.querySelector('.nm-product-hero');
      if (!heroEl) return;
      const sheet = document.getElementById('nm-tier-sheet-' + section.id.replace('shopify-section-', ''));
      if (!sheet || sheet.dataset.nmInit === 'true') return;
      sheet.dataset.nmInit = 'true';

      const body = sheet.querySelector('[data-nm-tier-body]');
      const addBtn = sheet.querySelector('[data-nm-tier-add]');
      const appBlocks = heroEl.querySelector('.nm-product-hero__app-blocks');
      const realSubmit = heroEl.querySelector('.nm-product-hero__submit');
      let placeholder = null;

      const restoreWidget = () => {
        if (placeholder && appBlocks) {
          placeholder.replaceWith(appBlocks);
          placeholder = null;
        }
      };
      const hideSheet = () => {
        sheet.classList.remove('is-open');
        sheet.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('nm-sheet-lock');
        const done = () => {
          restoreWidget();
          sheet.hidden = true;
          sheet.removeEventListener('transitionend', done);
        };
        sheet.addEventListener('transitionend', done);
        setTimeout(() => { if (!sheet.hidden) done(); }, 400);
      };
      const openSheet = () => {
        if (!appBlocks) { realSubmit?.click(); return; } // no bundle widget → add to cart directly
        if (!placeholder) {
          placeholder = document.createComment('nm-app-blocks-home');
          appBlocks.parentNode.insertBefore(placeholder, appBlocks);
        }
        body.appendChild(appBlocks);
        sheet.hidden = false;
        requestAnimationFrame(() => sheet.classList.add('is-open'));
        sheet.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('nm-sheet-lock');
      };

      sheet.querySelectorAll('[data-nm-tier-close]').forEach((btn) => btn.addEventListener('click', hideSheet));
      addBtn?.addEventListener('click', () => {
        restoreWidget();      // widget back home so the app reads its selection from the live DOM
        realSubmit?.click();  // trigger the real add-to-cart (same path as the on-page button)
        hideSheet();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && sheet.classList.contains('is-open')) hideSheet();
      });
      document.addEventListener('nm:open-tier-sheet', openSheet);
    };

    const initCurrent = () => {
      document.querySelectorAll('.shopify-section').forEach((section) => {
        if (section.querySelector('.nm-product-hero')) {
          initProductHero(section);
          initTierSheet(section);
          initStickyBar(section);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCurrent, { once: true });
    } else {
      initCurrent();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initProductHero(event.target);
      initTierSheet(event.target);
      initStickyBar(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nm-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initReviews = (section) => {
      if (!section || section.dataset.nmReviewsReady === 'true') return;
      section.dataset.nmReviewsReady = 'true';

      const dialog = section.querySelector('[data-nm-review-dialog]');
      const dialogImage = section.querySelector('[data-nm-review-dialog-image]');
      const closeButton = section.querySelector('[data-nm-review-close]');

      if (!dialog || !dialogImage) return;

      section.querySelectorAll('[data-nm-review-photo]').forEach((button) => {
        button.addEventListener('click', () => {
          const image = button.querySelector('img');
          if (!image) return;
          dialogImage.src = image.currentSrc || image.src;
          dialogImage.alt = image.alt || '';
          dialog.showModal();
        });
      });

      closeButton?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    };

    const initAll = () => {
      document.querySelectorAll('[data-nm-reviews]').forEach(initReviews);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initReviews(event.target.querySelector('[data-nm-reviews]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
